import { useI18n } from "vue-i18n";
import { computed } from "vue";

export const countries = [
  {
    names: {
      de: "Malaysia",
      en: "Malaysia",
      fr: "Malaisie",
      es: "Malasia"
    },
    code: "MY"
  },
  {
    names: {
      de: "Haiti",
      en: "Haiti",
      fr: "Haïti",
      es: "Haití"
    },
    code: "HT"
  },
  {
    names: {
      de: "Tadschikistan",
      en: "Tajikistan",
      fr: "Tadjikistan",
      es: "Tayikistán"
    },
    code: "TJ"
  },
  {
    names: {
      de: "Amerikanisch-Samoa",
      en: "American Samoa",
      fr: "Samoa américaines",
      es: "Samoa Americana"
    },
    code: "AS"
  },
  {
    names: {
      de: "Italien",
      en: "Italy",
      fr: "Italie",
      es: "Italia"
    },
    code: "IT"
  },
  {
    names: {
      de: "Mexiko",
      en: "Mexico",
      fr: "Mexique",
      es: "México"
    },
    code: "MX"
  },
  {
    names: {
      de: "Nordmazedonien",
      en: "North Macedonia",
      fr: "Macédoine du Nord",
      es: "Macedonia del Norte"
    },
    code: "MK"
  },
  {
    names: {
      de: "Samoa",
      en: "Samoa",
      fr: "Samoa",
      es: "Samoa"
    },
    code: "WS"
  },
  {
    names: {
      de: "Guernsey",
      en: "Guernsey",
      fr: "Guernesey",
      es: "Guernsey"
    },
    code: "GG"
  },
  {
    names: {
      de: "Laos",
      en: "Laos",
      fr: "Laos",
      es: "Laos"
    },
    code: "LA"
  },
  {
    names: {
      de: "Namibia",
      en: "Namibia",
      fr: "Namibie",
      es: "Namibia"
    },
    code: "NA"
  },
  {
    names: {
      de: "Britische Jungferninseln",
      en: "British Virgin Islands",
      fr: "Îles Vierges britanniques",
      es: "Islas Vírgenes del Reino Unido"
    },
    code: "VG"
  },
  {
    names: {
      de: "Kaimaninseln",
      en: "Cayman Islands",
      fr: "Îles Caïmans",
      es: "Islas Caimán"
    },
    code: "KY"
  },
  {
    names: {
      de: "Ägypten",
      en: "Egypt",
      fr: "Égypte",
      es: "Egipto"
    },
    code: "EG"
  },
  {
    names: {
      de: "Kambodscha",
      en: "Cambodia",
      fr: "Cambodge",
      es: "Camboya"
    },
    code: "KH"
  },
  {
    names: {
      de: "Cookinseln",
      en: "Cook Islands",
      fr: "Îles Cook",
      es: "Islas Cook"
    },
    code: "CK"
  },
  {
    names: {
      de: "Seychellen",
      en: "Seychelles",
      fr: "Seychelles",
      es: "Seychelles"
    },
    code: "SC"
  },
  {
    names: {
      de: "Israel",
      en: "Israel",
      fr: "Israël",
      es: "Israel"
    },
    code: "IL"
  },
  {
    names: {
      de: "Bolivien",
      en: "Bolivia",
      fr: "Bolivie",
      es: "Bolivia"
    },
    code: "BO"
  },
  {
    names: {
      de: "Åland",
      en: "Åland Islands",
      fr: "Ahvenanmaa",
      es: "Alandia"
    },
    code: "AX"
  },
  {
    names: {
      de: "Vereinigte Arabische Emirate",
      en: "United Arab Emirates",
      fr: "Émirats arabes unis",
      es: "Emiratos Árabes Unidos"
    },
    code: "AE"
  },
  {
    names: {
      de: "Grenada",
      en: "Grenada",
      fr: "Grenade",
      es: "Grenada"
    },
    code: "GD"
  },
  {
    names: {
      de: "China",
      en: "China",
      fr: "Chine",
      es: "China"
    },
    code: "CN"
  },
  {
    names: {
      de: "Grönland",
      en: "Greenland",
      fr: "Groenland",
      es: "Groenlandia"
    },
    code: "GL"
  },
  {
    names: {
      de: "Vatikanstadt",
      en: "Vatican City",
      fr: "Cité du Vatican",
      es: "Ciudad del Vaticano"
    },
    code: "VA"
  },
  {
    names: {
      de: "Vanuatu",
      en: "Vanuatu",
      fr: "Vanuatu",
      es: "Vanuatu"
    },
    code: "VU"
  },
  {
    names: {
      de: "Nauru",
      en: "Nauru",
      fr: "Nauru",
      es: "Nauru"
    },
    code: "NR"
  },
  {
    names: {
      de: "Mikronesien",
      en: "Micronesia",
      fr: "Micronésie",
      es: "Micronesia"
    },
    code: "FM"
  },
  {
    names: {
      de: "Salomonen",
      en: "Solomon Islands",
      fr: "Îles Salomon",
      es: "Islas Salomón"
    },
    code: "SB"
  },
  {
    names: {
      de: "Amerikanische Jungferninseln",
      en: "United States Virgin Islands",
      fr: "Îles Vierges des États-Unis",
      es: "Islas Vírgenes de los Estados Unidos"
    },
    code: "VI"
  },
  {
    names: {
      de: "Türkei",
      en: "Turkey",
      fr: "Turquie",
      es: "Turquía"
    },
    code: "TR"
  },
  {
    names: {
      de: "Kuwait",
      en: "Kuwait",
      fr: "Koweït",
      es: "Kuwait"
    },
    code: "KW"
  },
  {
    names: {
      de: "Senegal",
      en: "Senegal",
      fr: "Sénégal",
      es: "Senegal"
    },
    code: "SN"
  },
  {
    names: {
      de: "Burundi",
      en: "Burundi",
      fr: "Burundi",
      es: "Burundi"
    },
    code: "BI"
  },
  {
    names: {
      de: "Serbien",
      en: "Serbia",
      fr: "Serbie",
      es: "Serbia"
    },
    code: "RS"
  },
  {
    names: {
      de: "Brunei",
      en: "Brunei",
      fr: "Brunei",
      es: "Brunei"
    },
    code: "BN"
  },
  {
    names: {
      de: "Heard und die McDonaldinseln",
      en: "Heard Island and McDonald Islands",
      fr: "Îles Heard-et-MacDonald",
      es: "Islas Heard y McDonald"
    },
    code: "HM"
  },
  {
    names: {
      de: "Bahamas",
      en: "Bahamas",
      fr: "Bahamas",
      es: "Bahamas"
    },
    code: "BS"
  },
  {
    names: {
      de: "Bahrain",
      en: "Bahrain",
      fr: "Bahreïn",
      es: "Bahrein"
    },
    code: "BH"
  },
  {
    names: {
      de: "Dominikanische Republik",
      en: "Dominican Republic",
      fr: "République dominicaine",
      es: "República Dominicana"
    },
    code: "DO"
  },
  {
    names: {
      de: "Curaçao",
      en: "Curaçao",
      fr: "Curaçao",
      es: "Curazao"
    },
    code: "CW"
  },
  {
    names: {
      de: "Norfolkinsel",
      en: "Norfolk Island",
      fr: "Île Norfolk",
      es: "Isla de Norfolk"
    },
    code: "NF"
  },
  {
    names: {
      de: "Nordkorea",
      en: "North Korea",
      fr: "Corée du Nord",
      es: "Corea del Norte"
    },
    code: "KP"
  },
  {
    names: {
      de: "Tokelau",
      en: "Tokelau",
      fr: "Tokelau",
      es: "Islas Tokelau"
    },
    code: "TK"
  },
  {
    names: {
      de: "Südsudan",
      en: "South Sudan",
      fr: "Soudan du Sud",
      es: "Sudán del Sur"
    },
    code: "SS"
  },
  {
    names: {
      de: "Aruba",
      en: "Aruba",
      fr: "Aruba",
      es: "Aruba"
    },
    code: "AW"
  },
  {
    names: {
      de: "Tschechien",
      en: "Czechia",
      fr: "Tchéquie",
      es: "Chequia"
    },
    code: "CZ"
  },
  {
    names: {
      de: "Guadeloupe",
      en: "Guadeloupe",
      fr: "Guadeloupe",
      es: "Guadalupe"
    },
    code: "GP"
  },
  {
    names: {
      de: "Syrien",
      en: "Syria",
      fr: "Syrie",
      es: "Siria"
    },
    code: "SY"
  },
  {
    names: {
      de: "Marshallinseln",
      en: "Marshall Islands",
      fr: "Îles Marshall",
      es: "Islas Marshall"
    },
    code: "MH"
  },
  {
    names: {
      de: "Tansania",
      en: "Tanzania",
      fr: "Tanzanie",
      es: "Tanzania"
    },
    code: "TZ"
  },
  {
    names: {
      de: "Papua-Neuguinea",
      en: "Papua New Guinea",
      fr: "Papouasie-Nouvelle-Guinée",
      es: "Papúa Nueva Guinea"
    },
    code: "PG"
  },
  {
    names: {
      de: "Eritrea",
      en: "Eritrea",
      fr: "Érythrée",
      es: "Eritrea"
    },
    code: "ER"
  },
  {
    names: {
      de: "Moldawien",
      en: "Moldova",
      fr: "Moldavie",
      es: "Moldavia"
    },
    code: "MD"
  },
  {
    names: {
      de: "Usbekistan",
      en: "Uzbekistan",
      fr: "Ouzbékistan",
      es: "Uzbekistán"
    },
    code: "UZ"
  },
  {
    names: {
      de: "Frankreich",
      en: "France",
      fr: "France",
      es: "Francia"
    },
    code: "FR"
  },
  {
    names: {
      de: "Uruguay",
      en: "Uruguay",
      fr: "Uruguay",
      es: "Uruguay"
    },
    code: "UY"
  },
  {
    names: {
      de: "Kongo (Dem. Rep.)",
      en: "DR Congo",
      fr: "Congo (Rép. dém.)",
      es: "Congo (Rep. Dem.)"
    },
    code: "CD"
  },
  {
    names: {
      de: "St. Lucia",
      en: "Saint Lucia",
      fr: "Sainte-Lucie",
      es: "Santa Lucía"
    },
    code: "LC"
  },
  {
    names: {
      de: "Tuvalu",
      en: "Tuvalu",
      fr: "Tuvalu",
      es: "Tuvalu"
    },
    code: "TV"
  },
  {
    names: {
      de: "Kanada",
      en: "Canada",
      fr: "Canada",
      es: "Canadá"
    },
    code: "CA"
  },
  {
    names: {
      de: "Schweiz",
      en: "Switzerland",
      fr: "Suisse",
      es: "Suiza"
    },
    code: "CH"
  },
  {
    names: {
      de: "Gabun",
      en: "Gabon",
      fr: "Gabon",
      es: "Gabón"
    },
    code: "GA"
  },
  {
    names: {
      de: "Libyen",
      en: "Libya",
      fr: "Libye",
      es: "Libia"
    },
    code: "LY"
  },
  {
    names: {
      de: "Monaco",
      en: "Monaco",
      fr: "Monaco",
      es: "Mónaco"
    },
    code: "MC"
  },
  {
    names: {
      de: "Vereinigtes Königreich",
      en: "United Kingdom",
      fr: "Royaume-Uni",
      es: "Reino Unido"
    },
    code: "GB"
  },
  {
    names: {
      de: "Ruanda",
      en: "Rwanda",
      fr: "Rwanda",
      es: "Ruanda"
    },
    code: "RW"
  },
  {
    names: {
      de: "Bhutan",
      en: "Bhutan",
      fr: "Bhoutan",
      es: "Bután"
    },
    code: "BT"
  },
  {
    names: {
      de: "Saint-Barthélemy",
      en: "Saint Barthélemy",
      fr: "Saint-Barthélemy",
      es: "San Bartolomé"
    },
    code: "BL"
  },
  {
    names: {
      de: "Botswana",
      en: "Botswana",
      fr: "Botswana",
      es: "Botswana"
    },
    code: "BW"
  },
  {
    names: {
      de: "Indien",
      en: "India",
      fr: "Inde",
      es: "India"
    },
    code: "IN"
  },
  {
    names: {
      de: "Neuseeland",
      en: "New Zealand",
      fr: "Nouvelle-Zélande",
      es: "Nueva Zelanda"
    },
    code: "NZ"
  },
  {
    names: {
      de: "Irland",
      en: "Ireland",
      fr: "Irlande",
      es: "Irlanda"
    },
    code: "IE"
  },
  {
    names: {
      de: "Macao",
      en: "Macau",
      fr: "Macao",
      es: "Macao"
    },
    code: "MO"
  },
  {
    names: {
      de: "Neukaledonien",
      en: "New Caledonia",
      fr: "Nouvelle-Calédonie",
      es: "Nueva Caledonia"
    },
    code: "NC"
  },
  {
    names: {
      de: "Bulgarien",
      en: "Bulgaria",
      fr: "Bulgarie",
      es: "Bulgaria"
    },
    code: "BG"
  },
  {
    names: {
      de: "Swasiland",
      en: "Eswatini",
      fr: "Swaziland",
      es: "Suazilandia"
    },
    code: "SZ"
  },
  {
    names: {
      de: "Algerien",
      en: "Algeria",
      fr: "Algérie",
      es: "Argelia"
    },
    code: "DZ"
  },
  {
    names: {
      de: "Kenia",
      en: "Kenya",
      fr: "Kenya",
      es: "Kenia"
    },
    code: "KE"
  },
  {
    names: {
      de: "Mali",
      en: "Mali",
      fr: "Mali",
      es: "Mali"
    },
    code: "ML"
  },
  {
    names: {
      de: "Venezuela",
      en: "Venezuela",
      fr: "Venezuela",
      es: "Venezuela"
    },
    code: "VE"
  },
  {
    names: {
      de: "Bosnien und Herzegowina",
      en: "Bosnia and Herzegovina",
      fr: "Bosnie-Herzégovine",
      es: "Bosnia y Herzegovina"
    },
    code: "BA"
  },
  {
    names: {
      de: "Somalia",
      en: "Somalia",
      fr: "Somalie",
      es: "Somalia"
    },
    code: "SO"
  },
  {
    names: {
      de: "Norwegen",
      en: "Norway",
      fr: "Norvège",
      es: "Noruega"
    },
    code: "NO"
  },
  {
    names: {
      de: "Gambia",
      en: "Gambia",
      fr: "Gambie",
      es: "Gambia"
    },
    code: "GM"
  },
  {
    names: {
      de: "Estland",
      en: "Estonia",
      fr: "Estonie",
      es: "Estonia"
    },
    code: "EE"
  },
  {
    names: {
      de: "Belize",
      en: "Belize",
      fr: "Belize",
      es: "Belice"
    },
    code: "BZ"
  },
  {
    names: {
      de: "Paraguay",
      en: "Paraguay",
      fr: "Paraguay",
      es: "Paraguay"
    },
    code: "PY"
  },
  {
    names: {
      de: "Guinea",
      en: "Guinea",
      fr: "Guinée",
      es: "Guinea"
    },
    code: "GN"
  },
  {
    names: {
      de: "Luxemburg",
      en: "Luxembourg",
      fr: "Luxembourg",
      es: "Luxemburgo"
    },
    code: "LU"
  },
  {
    names: {
      de: "Südafrika",
      en: "South Africa",
      fr: "Afrique du Sud",
      es: "República de Sudáfrica"
    },
    code: "ZA"
  },
  {
    names: {
      de: "Jordanien",
      en: "Jordan",
      fr: "Jordanie",
      es: "Jordania"
    },
    code: "JO"
  },
  {
    names: {
      de: "Osttimor",
      en: "Timor-Leste",
      fr: "Timor oriental",
      es: "Timor Oriental"
    },
    code: "TL"
  },
  {
    names: {
      de: "Simbabwe",
      en: "Zimbabwe",
      fr: "Zimbabwe",
      es: "Zimbabue"
    },
    code: "ZW"
  },
  {
    names: {
      de: "Mosambik",
      en: "Mozambique",
      fr: "Mozambique",
      es: "Mozambique"
    },
    code: "MZ"
  },
  {
    names: {
      de: "Karibische Niederlande",
      en: "Caribbean Netherlands",
      fr: "Pays-Bas caribéens",
      es: "Caribe Neerlandés"
    },
    code: "BQ"
  },
  {
    names: {
      de: "Chile",
      en: "Chile",
      fr: "Chili",
      es: "Chile"
    },
    code: "CL"
  },
  {
    names: {
      de: "Deutschland",
      en: "Germany",
      fr: "Allemagne",
      es: "Alemania"
    },
    code: "DE"
  },
  {
    names: {
      de: "El Salvador",
      en: "El Salvador",
      fr: "Salvador",
      es: "El Salvador"
    },
    code: "SV"
  },
  {
    names: {
      de: "Guatemala",
      en: "Guatemala",
      fr: "Guatemala",
      es: "Guatemala"
    },
    code: "GT"
  },
  {
    names: {
      de: "Lesotho",
      en: "Lesotho",
      fr: "Lesotho",
      es: "Lesotho"
    },
    code: "LS"
  },
  {
    names: {
      de: "Peru",
      en: "Peru",
      fr: "Pérou",
      es: "Perú"
    },
    code: "PE"
  },
  {
    names: {
      de: "Sint Maarten",
      en: "Sint Maarten",
      fr: "Saint-Martin",
      es: "Sint Maarten"
    },
    code: "SX"
  },
  {
    names: {
      de: "Dschibuti",
      en: "Djibouti",
      fr: "Djibouti",
      es: "Djibouti"
    },
    code: "DJ"
  },
  {
    names: {
      de: "Französische Süd- und Antarktisgebiete",
      en: "French Southern and Antarctic Lands",
      fr: "Terres australes et antarctiques françaises",
      es: "Tierras Australes y Antárticas Francesas"
    },
    code: "TF"
  },
  {
    names: {
      de: "Australien",
      en: "Australia",
      fr: "Australie",
      es: "Australia"
    },
    code: "AU"
  },
  {
    names: {
      de: "Tschad",
      en: "Chad",
      fr: "Tchad",
      es: "Chad"
    },
    code: "TD"
  },
  {
    names: {
      de: "São Tomé und Príncipe",
      en: "São Tomé and Príncipe",
      fr: "São Tomé et Príncipe",
      es: "Santo Tomé y Príncipe"
    },
    code: "ST"
  },
  {
    names: {
      de: "Vereinigte Staaten",
      en: "United States",
      fr: "États-Unis",
      es: "Estados Unidos"
    },
    code: "US"
  },
  {
    names: {
      de: "Spanien",
      en: "Spain",
      fr: "Espagne",
      es: "España"
    },
    code: "ES"
  },
  {
    names: {
      de: "Aserbaidschan",
      en: "Azerbaijan",
      fr: "Azerbaïdjan",
      es: "Azerbaiyán"
    },
    code: "AZ"
  },
  {
    names: {
      de: "Dänemark",
      en: "Denmark",
      fr: "Danemark",
      es: "Dinamarca"
    },
    code: "DK"
  },
  {
    names: {
      de: "Fidschi",
      en: "Fiji",
      fr: "Fidji",
      es: "Fiyi"
    },
    code: "FJ"
  },
  {
    names: {
      de: "Polen",
      en: "Poland",
      fr: "Pologne",
      es: "Polonia"
    },
    code: "PL"
  },
  {
    names: {
      de: "Sierra Leone",
      en: "Sierra Leone",
      fr: "Sierra Leone",
      es: "Sierra Leone"
    },
    code: "SL"
  },
  {
    names: {
      de: "Palästina",
      en: "Palestine",
      fr: "Palestine",
      es: "Palestina"
    },
    code: "PS"
  },
  {
    names: {
      de: "Mauretanien",
      en: "Mauritania",
      fr: "Mauritanie",
      es: "Mauritania"
    },
    code: "MR"
  },
  {
    names: {
      de: "Russland",
      en: "Russia",
      fr: "Russie",
      es: "Rusia"
    },
    code: "RU"
  },
  {
    names: {
      de: "Malta",
      en: "Malta",
      fr: "Malte",
      es: "Malta"
    },
    code: "MT"
  },
  {
    names: {
      de: "Nicaragua",
      en: "Nicaragua",
      fr: "Nicaragua",
      es: "Nicaragua"
    },
    code: "NI"
  },
  {
    names: {
      de: "Spitzbergen und Jan Mayen",
      en: "Svalbard and Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      es: "Islas Svalbard y Jan Mayen"
    },
    code: "SJ"
  },
  {
    names: {
      de: "San Marino",
      en: "San Marino",
      fr: "Saint-Marin",
      es: "San Marino"
    },
    code: "SM"
  },
  {
    names: {
      de: "Ghana",
      en: "Ghana",
      fr: "Ghana",
      es: "Ghana"
    },
    code: "GH"
  },
  {
    names: {
      de: "Honduras",
      en: "Honduras",
      fr: "Honduras",
      es: "Honduras"
    },
    code: "HN"
  },
  {
    names: {
      de: "Malediven",
      en: "Maldives",
      fr: "Maldives",
      es: "Maldivas"
    },
    code: "MV"
  },
  {
    names: {
      de: "Nepal",
      en: "Nepal",
      fr: "Népal",
      es: "Nepal"
    },
    code: "NP"
  },
  {
    names: {
      de: "Taiwan",
      en: "Taiwan",
      fr: "Taïwan",
      es: "Taiwán"
    },
    code: "TW"
  },
  {
    names: {
      de: "Niger",
      en: "Niger",
      fr: "Niger",
      es: "Níger"
    },
    code: "NE"
  },
  {
    names: {
      de: "Slowakei",
      en: "Slovakia",
      fr: "Slovaquie",
      es: "República Eslovaca"
    },
    code: "SK"
  },
  {
    names: {
      de: "Libanon",
      en: "Lebanon",
      fr: "Liban",
      es: "Líbano"
    },
    code: "LB"
  },
  {
    names: {
      de: "Oman",
      en: "Oman",
      fr: "Oman",
      es: "Omán"
    },
    code: "OM"
  },
  {
    names: {
      de: "Niue",
      en: "Niue",
      fr: "Niue",
      es: "Niue"
    },
    code: "NU"
  },
  {
    names: {
      de: "Anguilla",
      en: "Anguilla",
      fr: "Anguilla",
      es: "Anguilla"
    },
    code: "AI"
  },
  {
    names: {
      de: "Singapur",
      en: "Singapore",
      fr: "Singapour",
      es: "Singapur"
    },
    code: "SG"
  },
  {
    names: {
      de: "Elfenbeinküste",
      en: "Ivory Coast",
      fr: "Côte d'Ivoire",
      es: "Costa de Marfil"
    },
    code: "CI"
  },
  {
    names: {
      de: "Kosovo",
      en: "Kosovo",
      fr: "Kosovo",
      es: "Kosovo"
    },
    code: "XK"
  },
  {
    names: {
      de: "Jersey",
      en: "Jersey",
      fr: "Jersey",
      es: "Jersey"
    },
    code: "JE"
  },
  {
    names: {
      de: "Rumänien",
      en: "Romania",
      fr: "Roumanie",
      es: "Rumania"
    },
    code: "RO"
  },
  {
    names: {
      de: "Slowenien",
      en: "Slovenia",
      fr: "Slovénie",
      es: "Eslovenia"
    },
    code: "SI"
  },
  {
    names: {
      de: "Insel Man",
      en: "Isle of Man",
      fr: "Île de Man",
      es: "Isla de Man"
    },
    code: "IM"
  },
  {
    names: {
      de: "Weißrussland",
      en: "Belarus",
      fr: "Biélorussie",
      es: "Bielorrusia"
    },
    code: "BY"
  },
  {
    names: {
      de: "Kuba",
      en: "Cuba",
      fr: "Cuba",
      es: "Cuba"
    },
    code: "CU"
  },
  {
    names: {
      de: "Montserrat",
      en: "Montserrat",
      fr: "Montserrat",
      es: "Montserrat"
    },
    code: "MS"
  },
  {
    names: {
      de: "Montenegro",
      en: "Montenegro",
      fr: "Monténégro",
      es: "Montenegro"
    },
    code: "ME"
  },
  {
    names: {
      de: "Kiribati",
      en: "Kiribati",
      fr: "Kiribati",
      es: "Kiribati"
    },
    code: "KI"
  },
  {
    names: {
      de: "Liechtenstein",
      en: "Liechtenstein",
      fr: "Liechtenstein",
      es: "Liechtenstein"
    },
    code: "LI"
  },
  {
    names: {
      de: "Palau",
      en: "Palau",
      fr: "Palaos (Palau)",
      es: "Palau"
    },
    code: "PW"
  },
  {
    names: {
      de: "Réunion",
      en: "Réunion",
      fr: "Réunion",
      es: "Reunión"
    },
    code: "RE"
  },
  {
    names: {
      de: "Saint-Martin",
      en: "Saint Martin",
      fr: "Saint-Martin",
      es: "Saint Martin"
    },
    code: "MF"
  },
  {
    names: {
      de: "Pitcairninseln",
      en: "Pitcairn Islands",
      fr: "Îles Pitcairn",
      es: "Islas Pitcairn"
    },
    code: "PN"
  },
  {
    names: {
      de: "Falklandinseln",
      en: "Falkland Islands",
      fr: "Îles Malouines",
      es: "Islas Malvinas"
    },
    code: "FK"
  },
  {
    names: {
      de: "Schweden",
      en: "Sweden",
      fr: "Suède",
      es: "Suecia"
    },
    code: "SE"
  },
  {
    names: {
      de: "Ungarn",
      en: "Hungary",
      fr: "Hongrie",
      es: "Hungría"
    },
    code: "HU"
  },
  {
    names: {
      de: "Marokko",
      en: "Morocco",
      fr: "Maroc",
      es: "Marruecos"
    },
    code: "MA"
  },
  {
    names: {
      de: "Kolumbien",
      en: "Colombia",
      fr: "Colombie",
      es: "Colombia"
    },
    code: "CO"
  },
  {
    names: {
      de: "Sudan",
      en: "Sudan",
      fr: "Soudan",
      es: "Sudán"
    },
    code: "SD"
  },
  {
    names: {
      de: "Hongkong",
      en: "Hong Kong",
      fr: "Hong Kong",
      es: "Hong Kong"
    },
    code: "HK"
  },
  {
    names: {
      de: "St. Helena, Ascension und Tristan da Cunha ",
      en: "Saint Helena, Ascension and Tristan da Cunha ",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha ",
      es: "Santa Elena, Ascensión y Tristán de Acuña "
    },
    code: "SH"
  },
  {
    names: {
      de: "Turkmenistan",
      en: "Turkmenistan",
      fr: "Turkménistan",
      es: "Turkmenistán"
    },
    code: "TM"
  },
  {
    names: {
      de: "Togo",
      en: "Togo",
      fr: "Togo",
      es: "Togo"
    },
    code: "TG"
  },
  {
    names: {
      de: "Argentinien",
      en: "Argentina",
      fr: "Argentine",
      es: "Argentina"
    },
    code: "AR"
  },
  {
    names: {
      de: "Saudi-Arabien",
      en: "Saudi Arabia",
      fr: "Arabie Saoudite",
      es: "Arabia Saudí"
    },
    code: "SA"
  },
  {
    names: {
      de: "Bermuda",
      en: "Bermuda",
      fr: "Bermudes",
      es: "Bermudas"
    },
    code: "BM"
  },
  {
    names: {
      de: "Ecuador",
      en: "Ecuador",
      fr: "Équateur",
      es: "Ecuador"
    },
    code: "EC"
  },
  {
    names: {
      de: "Äthiopien",
      en: "Ethiopia",
      fr: "Éthiopie",
      es: "Etiopía"
    },
    code: "ET"
  },
  {
    names: {
      de: "St. Kitts und Nevis",
      en: "Saint Kitts and Nevis",
      fr: "Saint-Christophe-et-Niévès",
      es: "San Cristóbal y Nieves"
    },
    code: "KN"
  },
  {
    names: {
      de: "Mauritius",
      en: "Mauritius",
      fr: "Île Maurice",
      es: "Mauricio"
    },
    code: "MU"
  },
  {
    names: {
      de: "Niederlande",
      en: "Netherlands",
      fr: "Pays-Bas",
      es: "Países Bajos"
    },
    code: "NL"
  },
  {
    names: {
      de: "Myanmar",
      en: "Myanmar",
      fr: "Birmanie",
      es: "Myanmar"
    },
    code: "MM"
  },
  {
    names: {
      de: "Kokosinseln",
      en: "Cocos (Keeling) Islands",
      fr: "Îles Cocos",
      es: "Islas Cocos o Islas Keeling"
    },
    code: "CC"
  },
  {
    names: {
      de: "Liberia",
      en: "Liberia",
      fr: "Liberia",
      es: "Liberia"
    },
    code: "LR"
  },
  {
    names: {
      de: "Turks-und Caicosinseln",
      en: "Turks and Caicos Islands",
      fr: "Îles Turques-et-Caïques",
      es: "Islas Turks y Caicos"
    },
    code: "TC"
  },
  {
    names: {
      de: "Tunesien",
      en: "Tunisia",
      fr: "Tunisie",
      es: "Túnez"
    },
    code: "TN"
  },
  {
    names: {
      de: "Westsahara",
      en: "Western Sahara",
      fr: "Sahara Occidental",
      es: "Sahara Occidental"
    },
    code: "EH"
  },
  {
    names: {
      de: "Finnland",
      en: "Finland",
      fr: "Finlande",
      es: "Finlandia"
    },
    code: "FI"
  },
  {
    names: {
      de: "Island",
      en: "Iceland",
      fr: "Islande",
      es: "Islandia"
    },
    code: "IS"
  },
  {
    names: {
      de: "Nördliche Marianen",
      en: "Northern Mariana Islands",
      fr: "Îles Mariannes du Nord",
      es: "Islas Marianas del Norte"
    },
    code: "MP"
  },
  {
    names: {
      de: "Guam",
      en: "Guam",
      fr: "Guam",
      es: "Guam"
    },
    code: "GU"
  },
  {
    names: {
      de: "Jamaika",
      en: "Jamaica",
      fr: "Jamaïque",
      es: "Jamaica"
    },
    code: "JM"
  },
  {
    names: {
      de: "Burkina Faso",
      en: "Burkina Faso",
      fr: "Burkina Faso",
      es: "Burkina Faso"
    },
    code: "BF"
  },
  {
    names: {
      de: "Antigua und Barbuda",
      en: "Antigua and Barbuda",
      fr: "Antigua-et-Barbuda",
      es: "Antigua y Barbuda"
    },
    code: "AG"
  },
  {
    names: {
      de: "Mongolei",
      en: "Mongolia",
      fr: "Mongolie",
      es: "Mongolia"
    },
    code: "MN"
  },
  {
    names: {
      de: "Benin",
      en: "Benin",
      fr: "Bénin",
      es: "Benín"
    },
    code: "BJ"
  },
  {
    names: {
      de: "Indonesien",
      en: "Indonesia",
      fr: "Indonésie",
      es: "Indonesia"
    },
    code: "ID"
  },
  {
    names: {
      de: "Georgien",
      en: "Georgia",
      fr: "Géorgie",
      es: "Georgia"
    },
    code: "GE"
  },
  {
    names: {
      de: "Albanien",
      en: "Albania",
      fr: "Albanie",
      es: "Albania"
    },
    code: "AL"
  },
  {
    names: {
      de: "Brasilien",
      en: "Brazil",
      fr: "Brésil",
      es: "Brasil"
    },
    code: "BR"
  },
  {
    names: {
      de: "Gibraltar",
      en: "Gibraltar",
      fr: "Gibraltar",
      es: "Gibraltar"
    },
    code: "GI"
  },
  {
    names: {
      de: "St. Vincent und die Grenadinen",
      en: "Saint Vincent and the Grenadines",
      fr: "Saint-Vincent-et-les-Grenadines",
      es: "San Vicente y Granadinas"
    },
    code: "VC"
  },
  {
    names: {
      de: "Iran",
      en: "Iran",
      fr: "Iran",
      es: "Iran"
    },
    code: "IR"
  },
  {
    names: {
      de: "Portugal",
      en: "Portugal",
      fr: "Portugal",
      es: "Portugal"
    },
    code: "PT"
  },
  {
    names: {
      de: "Kamerun",
      en: "Cameroon",
      fr: "Cameroun",
      es: "Camerún"
    },
    code: "CM"
  },
  {
    names: {
      de: "Dominica",
      en: "Dominica",
      fr: "Dominique",
      es: "Dominica"
    },
    code: "DM"
  },
  {
    names: {
      de: "Nigeria",
      en: "Nigeria",
      fr: "Nigéria",
      es: "Nigeria"
    },
    code: "NG"
  },
  {
    names: {
      de: "Südkorea",
      en: "South Korea",
      fr: "Corée du Sud",
      es: "Corea del Sur"
    },
    code: "KR"
  },
  {
    names: {
      de: "Angola",
      en: "Angola",
      fr: "Angola",
      es: "Angola"
    },
    code: "AO"
  },
  {
    names: {
      de: "Komoren",
      en: "Comoros",
      fr: "Comores",
      es: "Comoras"
    },
    code: "KM"
  },
  {
    names: {
      de: "Griechenland",
      en: "Greece",
      fr: "Grèce",
      es: "Grecia"
    },
    code: "GR"
  },
  {
    names: {
      de: "Belgien",
      en: "Belgium",
      fr: "Belgique",
      es: "Bélgica"
    },
    code: "BE"
  },
  {
    names: {
      de: "Puerto Rico",
      en: "Puerto Rico",
      fr: "Porto Rico",
      es: "Puerto Rico"
    },
    code: "PR"
  },
  {
    names: {
      de: "Kongo",
      en: "Republic of the Congo",
      fr: "Congo",
      es: "Congo"
    },
    code: "CG"
  },
  {
    names: {
      de: "Barbados",
      en: "Barbados",
      fr: "Barbade",
      es: "Barbados"
    },
    code: "BB"
  },
  {
    names: {
      de: "Antarktis",
      en: "Antarctica",
      fr: "Antarctique",
      es: "Antártida"
    },
    code: "AQ"
  },
  {
    names: {
      de: "Äquatorialguinea",
      en: "Equatorial Guinea",
      fr: "Guinée équatoriale",
      es: "Guinea Ecuatorial"
    },
    code: "GQ"
  },
  {
    names: {
      de: "Thailand",
      en: "Thailand",
      fr: "Thaïlande",
      es: "Tailandia"
    },
    code: "TH"
  },
  {
    names: {
      de: "Weihnachtsinsel",
      en: "Christmas Island",
      fr: "Île Christmas",
      es: "Isla de Navidad"
    },
    code: "CX"
  },
  {
    names: {
      de: "Guinea-Bissau",
      en: "Guinea-Bissau",
      fr: "Guinée-Bissau",
      es: "Guinea-Bisáu"
    },
    code: "GW"
  },
  {
    names: {
      de: "Panama",
      en: "Panama",
      fr: "Panama",
      es: "Panamá"
    },
    code: "PA"
  },
  {
    names: {
      de: "Lettland",
      en: "Latvia",
      fr: "Lettonie",
      es: "Letonia"
    },
    code: "LV"
  },
  {
    names: {
      de: "Guyana",
      en: "Guyana",
      fr: "Guyana",
      es: "Guyana"
    },
    code: "GY"
  },
  {
    names: {
      de: "Litauen",
      en: "Lithuania",
      fr: "Lituanie",
      es: "Lituania"
    },
    code: "LT"
  },
  {
    names: {
      de: "Jemen",
      en: "Yemen",
      fr: "Yémen",
      es: "Yemen"
    },
    code: "YE"
  },
  {
    names: {
      de: "Martinique",
      en: "Martinique",
      fr: "Martinique",
      es: "Martinica"
    },
    code: "MQ"
  },
  {
    names: {
      de: "Französisch-Guayana",
      en: "French Guiana",
      fr: "Guyane",
      es: "Guayana Francesa"
    },
    code: "GF"
  },
  {
    names: {
      de: "Suriname",
      en: "Suriname",
      fr: "Surinam",
      es: "Surinam"
    },
    code: "SR"
  },
  {
    names: {
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      en: "United States Minor Outlying Islands",
      fr: "Îles mineures éloignées des États-Unis",
      es: "Islas Ultramarinas Menores de Estados Unidos"
    },
    code: "UM"
  },
  {
    names: {
      de: "Zypern",
      en: "Cyprus",
      fr: "Chypre",
      es: "Chipre"
    },
    code: "CY"
  },
  {
    names: {
      de: "Kap Verde",
      en: "Cape Verde",
      fr: "Îles du Cap-Vert",
      es: "Cabo Verde"
    },
    code: "CV"
  },
  {
    names: {
      de: "Wallis und Futuna",
      en: "Wallis and Futuna",
      fr: "Wallis-et-Futuna",
      es: "Wallis y Futuna"
    },
    code: "WF"
  },
  {
    names: {
      de: "Mayotte",
      en: "Mayotte",
      fr: "Mayotte",
      es: "Mayotte"
    },
    code: "YT"
  },
  {
    names: {
      de: "Vietnam",
      en: "Vietnam",
      fr: "Viêt Nam",
      es: "Vietnam"
    },
    code: "VN"
  },
  {
    names: {
      de: "Französisch-Polynesien",
      en: "French Polynesia",
      fr: "Polynésie française",
      es: "Polinesia Francesa"
    },
    code: "PF"
  },
  {
    names: {
      de: "Trinidad und Tobago",
      en: "Trinidad and Tobago",
      fr: "Trinité-et-Tobago",
      es: "Trinidad y Tobago"
    },
    code: "TT"
  },
  {
    names: {
      de: "Malawi",
      en: "Malawi",
      fr: "Malawi",
      es: "Malawi"
    },
    code: "MW"
  },
  {
    names: {
      de: "Kroatien",
      en: "Croatia",
      fr: "Croatie",
      es: "Croacia"
    },
    code: "HR"
  },
  {
    names: {
      de: "Madagaskar",
      en: "Madagascar",
      fr: "Madagascar",
      es: "Madagascar"
    },
    code: "MG"
  },
  {
    names: {
      de: "Armenien",
      en: "Armenia",
      fr: "Arménie",
      es: "Armenia"
    },
    code: "AM"
  },
  {
    names: {
      de: "Österreich",
      en: "Austria",
      fr: "Autriche",
      es: "Austria"
    },
    code: "AT"
  },
  {
    names: {
      de: "St. Pierre und Miquelon",
      en: "Saint Pierre and Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      es: "San Pedro y Miquelón"
    },
    code: "PM"
  },
  {
    names: {
      de: "Afghanistan",
      en: "Afghanistan",
      fr: "Afghanistan",
      es: "Afganistán"
    },
    code: "AF"
  },
  {
    names: {
      de: "Zentralafrikanische Republik",
      en: "Central African Republic",
      fr: "République centrafricaine",
      es: "República Centroafricana"
    },
    code: "CF"
  },
  {
    names: {
      de: "Sambia",
      en: "Zambia",
      fr: "Zambie",
      es: "Zambia"
    },
    code: "ZM"
  },
  {
    names: {
      de: "Bangladesch",
      en: "Bangladesh",
      fr: "Bangladesh",
      es: "Bangladesh"
    },
    code: "BD"
  },
  {
    names: {
      de: "Costa Rica",
      en: "Costa Rica",
      fr: "Costa Rica",
      es: "Costa Rica"
    },
    code: "CR"
  },
  {
    names: {
      de: "Färöer-Inseln",
      en: "Faroe Islands",
      fr: "Îles Féroé",
      es: "Islas Faroe"
    },
    code: "FO"
  },
  {
    names: {
      de: "Uganda",
      en: "Uganda",
      fr: "Ouganda",
      es: "Uganda"
    },
    code: "UG"
  },
  {
    names: {
      de: "Kasachstan",
      en: "Kazakhstan",
      fr: "Kazakhstan",
      es: "Kazajistán"
    },
    code: "KZ"
  },
  {
    names: {
      de: "Bouvetinsel",
      en: "Bouvet Island",
      fr: "Île Bouvet",
      es: "Isla Bouvet"
    },
    code: "BV"
  },
  {
    names: {
      de: "Südgeorgien und die Südlichen Sandwichinseln",
      en: "South Georgia",
      fr: "Géorgie du Sud-et-les Îles Sandwich du Sud",
      es: "Islas Georgias del Sur y Sandwich del Sur"
    },
    code: "GS"
  },
  {
    names: {
      de: "Tonga",
      en: "Tonga",
      fr: "Tonga",
      es: "Tonga"
    },
    code: "TO"
  },
  {
    names: {
      de: "Ukraine",
      en: "Ukraine",
      fr: "Ukraine",
      es: "Ucrania"
    },
    code: "UA"
  },
  {
    names: {
      de: "Katar",
      en: "Qatar",
      fr: "Qatar",
      es: "Catar"
    },
    code: "QA"
  },
  {
    names: {
      de: "Andorra",
      en: "Andorra",
      fr: "Andorre",
      es: "Andorra"
    },
    code: "AD"
  },
  {
    names: {
      de: "Irak",
      en: "Iraq",
      fr: "Irak",
      es: "Irak"
    },
    code: "IQ"
  },
  {
    names: {
      de: "Sri Lanka",
      en: "Sri Lanka",
      fr: "Sri Lanka",
      es: "Sri Lanka"
    },
    code: "LK"
  },
  {
    names: {
      de: "Japan",
      en: "Japan",
      fr: "Japon",
      es: "Japón"
    },
    code: "JP"
  },
  {
    names: {
      de: "Kirgisistan",
      en: "Kyrgyzstan",
      fr: "Kirghizistan",
      es: "Kirguizistán"
    },
    code: "KG"
  },
  {
    names: {
      de: "Philippinen",
      en: "Philippines",
      fr: "Philippines",
      es: "Filipinas"
    },
    code: "PH"
  },
  {
    names: {
      de: "Pakistan",
      en: "Pakistan",
      fr: "Pakistan",
      es: "Pakistán"
    },
    code: "PK"
  },
  {
    names: {
      de: "Britisches Territorium im Indischen Ozean",
      en: "British Indian Ocean Territory",
      fr: "Territoire britannique de l'océan Indien",
      es: "Territorio Británico del Océano Índico"
    },
    code: "IO"
  }
];

type SimcisionLanguage = "en" | "de" | "fr" | "es";

export function useCountries() {
  const { locale } = useI18n();

  const localCountryNames = computed(() =>
    countries.map((c) => c.names[locale.value as SimcisionLanguage])
  );

  const countriesByCode = computed(() => {
    const dict: { [code: string]: string } = {};
    for (const country of countries) {
      dict[country.code] = country.names[locale.value as SimcisionLanguage];
    }
    return dict;
  });

  const countriesAutoCompleteList = computed(() => {
    return countries.map((c) => ({
      value: c.names[locale.value as SimcisionLanguage],
      label: c.names[locale.value as SimcisionLanguage]
    }));
  });

  function codeToName(countryCode: string) {
    return countriesByCode.value?.[countryCode] ?? countryCode;
  }
  function nameToCode(countryName: string) {
    for (const country of countries) {
      if (country.names[locale.value as SimcisionLanguage] === countryName) {
        return country.code;
      }
    }
    console.warn("could not find country code for", countryName);
    return "";
  }

  return {
    codeToName,
    nameToCode,
    localCountryNames,
    countriesByCode,
    countriesAutoCompleteList
  };
}
